import React from 'react'

const ComplexAuto = (item, vdebug) => {
    var wkdesc = 'unknown'
    if (!item.autopull) {
        wkdesc = 'manual'
    } else if (item.disable_request  || !item.aureqlock) {
        wkdesc = 'auto read'
    } else if (item.autorequest) {
          wkdesc = 'auto request'
    } else {
        wkdesc = 'full auto'
    }
    return(
        <div> {wkdesc}
        { vdebug && showAutoDebug(item) }
        </div>
        )
}

const showAutoDebug = (item) => {
    return(
        <span> autopull:( {item.autopull} )
               autorequest:( {item.autorequest} )
               aureqlock:( {item.reqlock} )
               disable_request:( {item.disable_request} )
        </span>
        )
}

export default ComplexAuto
